/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BulkTagRemediationResponse {
    getFixupPrototypeFunction() { return BulkTagRemediationResponse.fixupPrototype; }

    static newInstance(model: Partial<BulkTagRemediationResponse>): BulkTagRemediationResponse {
        let obj = Object.assign(new BulkTagRemediationResponse(), model);
        BulkTagRemediationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BulkTagRemediationResponse>): BulkTagRemediationResponse {
        if (!model) return null;
        return BulkTagRemediationResponse.newInstance(<BulkTagRemediationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BulkTagRemediationResponse) {
        if (!obj) return;

        models.BulkTagRemediationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BulkTagRemediationResponse): boolean {
        Object.setPrototypeOf(obj, BulkTagRemediationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tag Remediation Ids
     */
    resource_enforce_tag_ids: Array<string>;

}
